import React from "react";
import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import ActivitiesCompleted from "../ActivitiesCompleted/ActivitiesCompleted";
import ProgressBar from "../ProgressBar/ProgressBar";

const SearchResultsHeader = ({ numResults, searchInput }) => {
  return (
    <Typography variant="h4" color="textSecondary">
      {numResults +
        " Search Result" +
        (numResults === 1 ? "" : "s") +
        ' found for "' +
        searchInput +
        '"'}
    </Typography>
  );
};

const CoursePlayerTabHeader = ({
  numSearchResults,
  searchInput,
  totalActivities,
  numActivitiesCompleted,
  isTableOfContents,
  hideProgress
}) => {
  if (!!searchInput) {
    return (
      <Box mb={5}>
        <SearchResultsHeader
          numResults={numSearchResults}
          searchInput={searchInput}
        />
      </Box>
    );
  } else if (isTableOfContents && !hideProgress) {
    return (
      <Box display="flex" flexDirection="column" width="100%" mb={5}>
        <Box mb={1}>
          <ActivitiesCompleted
            fontSize="1.125rem"
            totalSteps={totalActivities}
            completedSteps={numActivitiesCompleted}
          />
        </Box>
        <ProgressBar
          totalSteps={totalActivities}
          completedSteps={numActivitiesCompleted}
        />
      </Box>
    );
  } else {
    return null;
  }
};

export default CoursePlayerTabHeader;

CoursePlayerTabHeader.propTypes = {
  numActivitiesCompleted: PropTypes.number,
  totalActivities: PropTypes.number,
  searchInput: PropTypes.string,
  numModules: PropTypes.number,
  hideProgress: PropTypes.bool
};

CoursePlayerTabHeader.defaultProps = {
  hideProgress: false
};
